import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AteneaModule, MaterialModule } from "@atenea-cms";
import { SeriesRoutes } from "./series.routes";
import { SerieListComponent } from "./serie-list/serie-list.component";
import { SerieFormComponent } from "./serie-form/serie-form.component";
import { SerieService, SerieFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AteneaModule,
    MaterialModule,
    SeriesRoutes,
  ],
  declarations: [SerieListComponent, SerieFormComponent],
  providers: [SerieService, SerieFormService],
})
export class SeriesModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/series/series.module.ts